import { render, staticRenderFns } from "./FontSizeSelector.vue?vue&type=template&id=3b736aa6&scoped=true"
import script from "./FontSizeSelector.vue?vue&type=script&lang=js"
export * from "./FontSizeSelector.vue?vue&type=script&lang=js"
import style0 from "./FontSizeSelector.vue?vue&type=style&index=0&id=3b736aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b736aa6",
  null
  
)

export default component.exports